import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { encryptStorage, environment } from 'environments/environment';
import { map } from 'rxjs/operators';
import { Result } from 'app/main/shared/result';
import { User } from 'app/auth/model/user';
import { Router, RouterStateSnapshot } from '@angular/router';


@Injectable({
    providedIn: 'root'
  })

  export class ForgetPasswordService {
    constructor(private http: HttpClient,  private router: Router) { }


    public reset(userModel: User) {
        return this.http.post<Result>(environment.apiUrl+"/LoginManagement/ResetPassword", userModel)
          .pipe(map(value => {
            return value;
          }));
      }

  }